import { render, staticRenderFns } from "./JsonSchemaForm.vue?vue&type=template&id=2f864959&scoped=true&"
import script from "./JsonSchemaForm.vue?vue&type=script&lang=js&"
export * from "./JsonSchemaForm.vue?vue&type=script&lang=js&"
import style0 from "./JsonSchemaForm.vue?vue&type=style&index=0&id=2f864959&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f864959",
  null
  
)

export default component.exports